import { schema, Schema } from './groups-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { useParams } from '~/hooks/useParams';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';
import { idParamSchema } from '~/schemas';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
  competitionStartDate?: string;
}

export function GroupsForm({ defaultValues, mode, isLoading, onSubmit, competitionStartDate }: Props) {
  const { id } = useParams(idParamSchema.parse);

  const { formState, register, handleSubmit } = useForm({
    values: defaultValues ?? { competition: id, name: '', start: competitionStartDate ?? '' },
    resetOptions: { keepDirtyValues: true },
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" style={{ display: 'flex', gap: 'var(--size-4)' }}>
      <div style={{ flex: 1 }}>
        <Input.Group formState={formState} htmlFor="name" label="Namn">
          <Input.Field type="text" {...register('name')} />
        </Input.Group>
      </div>

      <div style={{ flex: 1 }}>
        <Input.Group formState={formState} htmlFor="start" label="Startdatum">
          <Input.Field type="date" {...register('start')} min={competitionStartDate} />
        </Input.Group>
      </div>

      <div style={{ marginTop: '22px' }}>
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </div>
    </form>
  );
}
